import angular from 'angular';

SatisfactionSurveyDetailsController.$inject = [
  'TopToolbarFactory',
  '$scope',
  'ParametersFactory',
  '$translate',
  'DropdownItemsFactory',
  '$state',
  '$stateParams',
  'survey',
  'site',
  'StrategiesFactory',
  'AlertingFactory',
  'company',
  'ClicksMetricHelperFactory',
  'QuickRepliesFactory',
  'MediasFactory',
  'allScenarios',
];
export function SatisfactionSurveyDetailsController(
  TopToolbarFactory,
  $scope,
  ParametersFactory,
  $translate,
  DropdownItemsFactory,
  $state,
  $stateParams,
  survey,
  site,
  StrategiesFactory,
  AlertingFactory,
  company,
  ClicksMetricHelperFactory,
  QuickRepliesFactory,
  MediasFactory,
  allScenarios
) {

  init();
  $scope.allScenarios = allScenarios;
  $scope.save = save;
  $scope.isMarketing = $state.current.data.isMarketingMode;
  $scope.onModelChange = onModelChange;
  $scope.exportMetricData = exportMetricData;


  function save() {
    survey.tags_ids = [];
    for (let groupId in $scope.tagsGroupModels) {
      $scope.tagsGroupModels[groupId].forEach(tagId => survey.tags_ids.push(tagId));
    }
    ParametersFactory.updateSatisfactionSurvey($stateParams.companyId, $stateParams.siteId, $stateParams.satisfactionSurveyId, survey)
      .then(() => {
        AlertingFactory.success('parameters/satisfaction_surveys/update_satisfaction_survey/ok');
        onModelPristine();
      },
        () => AlertingFactory.error('parameters/satisfaction_surveys/update_satisfaction_survey/ko'));
  }

  function exportMetricData() {
    QuickRepliesFactory.createBoxClicksExports(
      $stateParams.companyId,
      $stateParams.siteId,
      survey.scenario.common.id,
      $scope.clicksMetric.metricData
    ).then(response => {
      MediasFactory.downloadFile(response.data.url);
    }, AlertingFactory.httpErrorHandler());
  }

  function booleanOptions() {
    let options = [
      { name: $translate.instant('yes'), value: 1 },
      { name: $translate.instant('no'), value: 0 }
    ];
    return options;
  }

  function intOptions(values) {
    return values.map(v => ({
      name: v,
      value: v
    }));
  }

  function neverOption() {
    return {
      name: $translate.instant('parameters/never'),
      value: 'never'
    }
  }

  function actorOptions() {
    return [
      { name: $translate.instant('parameters/satisfaction_surveys/actors_type/all'), value: null },
      { name: $translate.instant('parameters/satisfaction_surveys/actors_type/only_humans'), value: 1 },
      { name: $translate.instant('parameters/satisfaction_surveys/actors_type/both_humans_and_bots'), value: 3 }
    ];
  }

  function initModel() {
    let strategy = StrategiesFactory.getStrategy(site.type_name);
    $scope.survey = survey;

    $scope.userSendDelayOptions = intOptions([0, 2, 15, 30, 45, 60, 75, 90]);

    if (!$scope.isMarketing) {
      $scope.expirationHoursOptions = intOptions(strategy.getSatisfactionSurveysExpirationHoursOptions());
      $scope.expirationHoursOptions.unshift(neverOption());

      $scope.sendInPrivateOptions = booleanOptions();

      if (!angular.equals($scope.survey.tasks_types, strategy.getPrivateTaskTypes())) {
        $scope.survey.tasks_types = strategy.getPrivateTaskTypes();  // Set the value for the backend
        onModelChange();
      }

      $scope.tagsGroupsOptions = DropdownItemsFactory.buildTagItems(company.tags_groups);
      $scope.tagsGroupModels = {};
      $scope.tagsGroupsOptions.forEach(tagsGroup => {
        $scope.tagsGroupModels[tagsGroup.id] = [];
        tagsGroup.items.forEach(category => {
          category.subitems.forEach(tag => {
            if (survey.tags_ids.includes(tag.id)) {
              $scope.tagsGroupModels[tagsGroup.id].push(tag.id);
            }
          })
        })
      });
      $scope.actorsTypeOptions = actorOptions();
    }
  }

  function onModelChange() {
    $scope.modelHasChanged.value = true;
  }

  function onModelPristine() {
    $scope.modelHasChanged = { value: false };
  }

  function switchUpated(booleanValue) {
    $scope.survey.is_active = booleanValue ? 1 : 0;
    onModelChange();
  }

  function init() {
    $scope.selectedTabIndex = $stateParams.selectedTabIndex || 0;
    $scope.$watch('survey.name', newValue => TopToolbarFactory.setTitle(newValue, $scope));
    TopToolbarFactory.setButton('save', save, $scope, 'save-survey');
    $scope.$watch('surveyForm.$invalid || !modelHasChanged.value',
      newValue => TopToolbarFactory.updateButtonDisable(newValue, $scope));
    const switchTranslationKey = 'parameters/satisfaction_surveys/active_column';
    const switchValue = survey.is_active === 1;
    TopToolbarFactory.setSwitch(switchTranslationKey, switchValue, switchUpated, $scope, 'toggle-activate-survey');
    onModelPristine();
    initModel();
    $scope.siteIcon = site.type_name;
    $scope.siteName = site.name;
    $scope.companyId = site.company.id;
    $scope.site = site;

    if ($scope.survey.scenario) {
      ClicksMetricHelperFactory.maybeInitScenarioMetrics($scope, site, $scope.survey.scenario.common.id);
    }

    if (!$scope.isMarketing) {
      $scope.tagsGroupsLabels = $scope.tagsGroupsOptions
        .map(tg => `${$translate.instant('parameters/satisfaction_surveys/tags')} ${tg.label}`);
    }

  }

}
